import { jsx as _jsx } from "react/jsx-runtime";
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { DefaultTabKey } from 'console/shared/content/tab/types';
import { useDeviceConfig } from 'console/shared/contexts/device/config';
import { useDeviceState } from 'console/shared/contexts/device/state';
import { useHeatingCircuit } from 'console/shared/components/panels/heating-circuits/heating-circuit/provider';
import { memo, useCallback, useMemo } from 'react';
import { OnlyViewHeatingCircuitCard } from './only-view';
import { ServiceHeatingCircuitCard } from './service';
import { SimpleHeatingCircuitCard } from './simple';
export const HeatingCircuitCard = memo(function HeatingCircuitCard(props) {
    const { onClick } = props;
    const { id, ...rest } = useHeatingCircuit();
    const { is_service_mode } = useDeviceState();
    const { tab_key } = useDeviceConfig();
    const nextUiGuide = useAppSelector((state) => state.ui_guide_state.store_helpers.next);
    const onCardClick = useCallback(() => {
        onClick(id);
        nextUiGuide?.();
    }, [id, nextUiGuide]);
    const Card = useMemo(() => {
        if (is_service_mode) {
            return ServiceHeatingCircuitCard;
        }
        if (tab_key === DefaultTabKey.house_tab) {
            return OnlyViewHeatingCircuitCard;
        }
        return SimpleHeatingCircuitCard;
    }, [is_service_mode, tab_key]);
    return _jsx(Card, { onClick: onCardClick });
});
